import { __ } from '@wordpress/i18n';

const bites = {
  id: 'bites',
  label: __('Bites & Groups', 'blockbite'),
  helper: __('Needs to be added as a modifier', 'blockbite'),
  modifiers: [
    {
      id: 'bites',
      label: __('Bite Styles', 'blockbite'),
      selector: false,
      className: 'icon',
      dynamicControl: 'BitesGroups',
    },
    {
      id: 'preset',
      label: __('Preset Styles', 'blockbite'),
      selector: false,
      className: 'icon',
      dynamicControl: 'BitesGroups',
    },
  ],
};

export const bitesPanel = {
  id: 'bites',
  label: 'Bites & Groups',
  visibility: 'hidden',
  controls: [bites],
};

export default { bitesPanel };
